import React from 'react';
import LoginForm from './LoginForm';
import  './Components.css';

function Login() {
  return (
    <div className='container loginFormOutlet'>
      <LoginForm/>
    </div>
  );
}

export default Login;
